<template>
  <b-list-group>
    <b-list-group-item class="questions" v-for="(question, i) in questions" :key="question.id">
      <div class="d-flex justify-content-between" v-b-toggle="'question' + question.id">
        <span>{{ i + 1 }}. {{ question.the_question }}</span>
        <b-icon-caret-down v-if="!isVisible(question.id)"></b-icon-caret-down>
        <b-icon-caret-up-fill v-else></b-icon-caret-up-fill>
      </div>
      <b-collapse
        class="mt-3"
        :id="`question${question.id}`"
        :visible="isVisible(question.id)"
        @show="showQuestion(question.id)"
        @hide="clearCrosstab()"
        accordion="questions"
      >
        <b-form-checkbox-group class="mb-3" v-model="localContentAsset.filter_data">
          <div v-if="question.type == 'Nps'">
            <table class="nps_table w-100 mt-5">
              <tr>
                <td>
                  <h5>NPS Score</h5>
                </td>
                <td v-for="answer in question.answers" :key="answer.id">
                  <div class="nps">
                    <div
                      class="nps-button"
                      :class="selectedClass(answer)"
                      @click.prevent="addAnswer(answer.id)"
                    >
                      {{ answer.the_answer }}
                    </div>
                  </div>
                </td>
              </tr>
              <tr class="responses">
                <td>
                  <h5>Responses</h5>
                </td>
                <td v-for="answer in question.answers" :key="answer.id">
                  {{ answer.response_count }}
                </td>
              </tr>
            </table>
          </div>
          <div class="answers" v-else>
            <table class="w-100 mb-4">
              <thead>
                <tr>
                  <th>
                    <h5>#</h5>
                  </th>
                  <th>
                    <h5>Answer Choice</h5>
                  </th>
                  <th>
                    <h5>Responses</h5>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(answer, i) in question.answers"
                  :key="answer.id"
                  @click.prevent="addAnswer(answer.id)"
                >
                  <td class="check">
                    <b-form-checkbox :value="answer.id" @click.prevent="addAnswer(answer.id)"
                      >{{ i + 1 }}.</b-form-checkbox
                    >
                  </td>
                  <td>
                    <span v-if="answer.freeform">Other</span>
                    <span v-else>{{ answer.the_answer }}</span>
                  </td>
                  <td>{{ answer.response_count }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-form-checkbox-group>
        <b-link @click="chooseAllAnswers(question.answers)">Select All Answers</b-link>
      </b-collapse>
    </b-list-group-item>
    <b-link class="mt-2" @click="localContentAsset.filter_data = []">Clear Answers</b-link>
  </b-list-group>
</template>
<script lang="ts">
export default {
  props: {
    contentAsset: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      currentQuestion: null,
      localContentAsset: this.contentAsset,
    }
  },
  mounted() {
    this.currentQuestion = this.questions.find((q) =>
      q.answers.some((a) => this.localContentAsset.filter_data.includes(a.id)),
    )
  },
  computed: {
    questions() {
      return this.localContentAsset.survey.questions
    },
  },
  methods: {
    isVisible(questionId) {
      return this.currentQuestion?.id === questionId
    },
    showQuestion(questionId) {
      this.currentQuestion = this.questions.find((q) => q.id == questionId)
    },
    clearCrosstab() {
      // TODO: is this the desired affect to blank out
      // checekd answers when the question is closed?
      // with out this, you will be able to select answers from
      // multiple questions at once
      // this.localContentAsset.filter_data = []
    },
    addAnswer(value) {
      if (this.localContentAsset.filter_data.includes(value))
        this.localContentAsset.filter_data = this.localContentAsset.filter_data.filter(
          (a) => a != value,
        )
      else this.localContentAsset.filter_data.push(value)
    },
    selectedClass(answer) {
      return this.localContentAsset.filter_data.includes(answer.id) ? 'selected' : ''
    },
    chooseAllAnswers(answers) {
      this.localContentAsset.filter_data = answers.map((a: { id: unknown }) => a.id)
    },
  },
}
</script>
